import FederatedUserIcon from "assets/federated-user.svg";
import PortalAdminUserIcon from "assets/portal-admin-user.svg";
import FederatedPortalAdminUserIcon from "assets/federated-portal-admin-user.svg";

interface UserIconProps {
  isFederatedUser: boolean,
  isPortalAdminUser: boolean,
  size?: number
}

export const UserIcon = ({ isFederatedUser, isPortalAdminUser, size } : UserIconProps) => (
  <>
    {isFederatedUser && !isPortalAdminUser
                            && (
                              <img
                                data-testid="imgFederated"
                                className="user-icon"
                                src={FederatedUserIcon}
                                alt="Federated User"
                                width={size || 32}
                                aria-label="Federated User"
                              />
                            )}
    {isPortalAdminUser && !isFederatedUser
                            && (
                              <img
                                data-testid="imgPortalAdmin"
                                className="user-icon"
                                src={PortalAdminUserIcon}
                                alt="Federated User"
                                width={size || 32}
                                aria-label="Portal Admin User"
                              />
                            )}
    {isPortalAdminUser && isFederatedUser
                            && (
                              <img
                                data-testid="imgFederatedPortalAdmin"
                                className="user-icon"
                                src={FederatedPortalAdminUserIcon}
                                alt="Federated Portal Admin User"
                                width={size || 32}
                                aria-label="Federated Portal Admin User"
                              />
                            )}

  </>
);
